import { render, staticRenderFns } from "./v-audit.vue?vue&type=template&id=04174f84&"
import script from "./v-audit.vue?vue&type=script&lang=js&"
export * from "./v-audit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports